import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import axios from 'axios';
import Typography from '@material-ui/core/Typography';

import Loader from '../Loader';
import BarGraph from '../BarGraph';
import PieChart from '../PieChart';

class MPTrackVisualization extends React.Component {
  static propTypes = {
    apiEndPoint: PropTypes.string.isRequired,
  };

  state = {
    dataLoaded: false,
    data: null,
    error: null,
  };

  componentDidMount() {
    this.fetchVisualizationData();
  }

  fetchVisualizationData = async () => {
    try {
      const {
        data: { data },
      } = await axios.get(this.props.apiEndPoint);
      this.setState({ dataLoaded: true, data });
    } catch (error) {
      this.setState({ dataLoaded: true, error: error.message });
    }
  };

  render() {
    return (
      <div>
        {this.state.error ? (
          <Typography variant="subheading" color="error">
            {this.state.error}
          </Typography>
        ) : !this.state.dataLoaded ? (
          <Loader />
        ) : (
          <div>
            {this.state.data && (
              <GraphsContainer>
                {this.state.data.map((graph) => {
                  const {
                    id, type, colSpan, ...config
                  } = graph;
                  return (
                    <GraphContainer key={graph.id} fullWidth={colSpan === 2}>
                      {type === 'BAR' ? (
                        <BarGraph config={config} />
                      ) : type === 'PIE' ? (
                        <PieChart config={config} />
                      ) : null}
                    </GraphContainer>
                  );
                })}
              </GraphsContainer>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default MPTrackVisualization;

const GraphsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
`;

const GraphContainer = styled.div`
  ${props => props.fullWidth
    && css`
      grid-column-start: 1;
      grid-column-end: 3;
    `};
`;



// WEBPACK FOOTER //
// ./src/components/SessionVisualization/SessionVisualization.js